import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Head () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.headNormocephalkANDtemporalWasting.name}
            options={[
              {
                label: 'Normocephalic',
                value: 'Normocephalic'
              },
              {
                label: 'Temporal Wasting',
                value: 'Temporal Wasting'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.headAtraumaticANDstructuralAnomaly.name}
            options={[
              {
                label: 'Atraumatic',
                value: 'Atraumatic'
              },
              {
                label: 'Structural Anomaly',
                value: 'Structural Anomaly'
              }
            ]}
          />
        </div>

        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.headOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.headOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Head
